import TagManager from 'react-gtm-module';

export const CONSENT_STORAGE_KEY = 'hostsoft-cookie-consent';
export const CONSENT_VERSION = 2;
export const OPEN_COOKIE_SETTINGS_EVENT = 'hostsoft:open-cookie-settings';

// Google Tag Manager
// https://tagmanager.google.com/#/container/accounts/6004253762/containers/47546005/workspaces/2
const GTM_ID = 'GTM-T6SJ9PR';

function gtag() {
  // Consent Mode expects the Arguments object, not an array
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}

export const readConsent = () => {
  try {
    const stored = JSON.parse(window.localStorage.getItem(CONSENT_STORAGE_KEY));
    if (!stored || stored.version !== CONSENT_VERSION) {
      return null;
    }
    return { analytics: stored.analytics === true, marketing: stored.marketing === true };
  } catch (e) {
    return null;
  }
};

export const saveConsent = ({ analytics, marketing }) => {
  try {
    window.localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify({
      version: CONSENT_VERSION,
      analytics,
      marketing,
      updatedAt: new Date().toISOString(),
    }));
    // Consents from the old banner are not reused
    window.localStorage.removeItem('cookies');
    window.localStorage.removeItem('cookies_marketing');
  } catch (e) {
    // storage unavailable: the banner shows again on the next page
  }
};

export const applyConsent = (consent) => {
  window.dataLayer = window.dataLayer || [];
  if (!window.hostsoftConsentDefault) {
    window.hostsoftConsentDefault = true;
    gtag('consent', 'default', {
      analytics_storage: 'denied',
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
    });
  }

  if (!consent) {
    return;
  }

  const ads = consent.marketing ? 'granted' : 'denied';
  gtag('consent', 'update', {
    analytics_storage: consent.analytics ? 'granted' : 'denied',
    ad_storage: ads,
    ad_user_data: ads,
    ad_personalization: ads,
  });

  if ((consent.analytics || consent.marketing) && !window.hostsoftGtmLoaded) {
    window.hostsoftGtmLoaded = true;
    TagManager.initialize({ gtmId: GTM_ID });
  }
};

export const openCookieSettings = () => {
  window.dispatchEvent(new Event(OPEN_COOKIE_SETTINGS_EVENT));
};
